import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login'
import Layout from '@/views/Layout'
import Home from '@/views/Home'
import Field from '@/views/Field'
import FieldDetail from '@/views/Field/indexdetail'
import User from '@/views/User'
import CommentList from '@/views/User/Comment/CommentList'
import AddComment from '@/views/User/Comment/AddComment'
import Echarts from '@/views/Echarts'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/layout'
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/layout',
    component: Layout,
    redirect: '/layout/home',
    children: [
      // 一级path需要'/'，二级path不需要
      {
        // 首页
        name: 'home',
        path: 'home',
        component: Home,
        meta: {
          // 元信息 -> 给当前路由对象绑定值
          title: '曙光厨房监管中心'
        }
      },
      {
        // 数据统计
        name: 'field',
        path: 'field',
        component: Field,
        meta: {
          title: '数据统计'
        }
      },
      {
        // 数据统计详情
        name: 'fieldDetail',
        path: 'field/indexdetail',
        component: FieldDetail,
        meta: {
          title: '详情'
        }
      },
      {
        // 个人中心
        name: 'user',
        path: 'user',
        component: User,
        meta: {
          title: '个人中心'
        }
      }
    ]
  },

  {
    // 用户 - 意见建议列表
    path: '/comment_list',
    component: CommentList
  },
  {
    // 用户 - 意见建议 - 我要反馈
    name: 'addComment',
    path: '/add_comment',
    component: AddComment
  },
  {
    // 图表
    name: 'echarts',
    path: '/echarts',
    component: Echarts
  }
]


const router = new VueRouter({
  routes
})

export default router
